export const primaryColor = {
  main: '#264FDD',
  lighter: '#466af7',
  light: '#466af7',
  dark: '#002486',
  darker: '#001354',
  contrastText: '#fff',
};
export const neutralColor = '#D8DAE5';
